import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import { AlertsComponent, AlertsService, SpinnerFilledComponent } from '@web/shared/ui';
import { AdminCartSettingsFormComponent } from '../admin-cart-settings-form/admin-cart-settings-form.component';
import { AdminCartSettingsFormData } from '../../models/admin-cart-settings-form-data';
import { AdminCartDataSourceService } from '../../services';

@Component({
  selector: 'app-admin-cart-settings',
  imports: [
    CommonModule,
    AlertsComponent,
    SpinnerFilledComponent,
    AdminCartSettingsFormComponent,
  ],
  templateUrl: './admin-cart-settings.component.html',
  styleUrl: './admin-cart-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminCartSettingsComponent implements OnInit {
  private readonly cartDataSource = inject(AdminCartDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  protected data$!: Observable<AdminCartSettingsFormData>;

  public ngOnInit(): void {
    this.data$ = this.cartDataSource.fetchSettingsFormData();
  }

  public handleSubmitClick(data: AdminCartSettingsFormData): void {
    this.cartDataSource
      .updateSettingsByFormData(data)
      .pipe(once())
      .subscribe({
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
